(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'siteHeader', {
            templateUrl: 'app/views/partials/layout/site-header.html',
            controller:  HeaderController,
            controllerAs:'vm'
        });

    /**
     * Renders header common for all the views on the website.
     *
     * @type {ng.IController}
     *
     * @param {ng.IScope} $scope
     * @param {ng.IWindowService} $scope
     * @param {*} $uiRouterGlobals
     * @param {*} $animate
     * @param {ng.IElement} $element
     * @param {LoggerFactory} LoggerFactory
     * @param {DataService} DataService
     * @param {SubpagesService} SubpagesService
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function HeaderController(
        $scope,
        $window,
        $uiRouterGlobals,
        $animate,
        $element,
        LoggerFactory,
        DataService,
        SubpagesService,
        App,
        TEXTS,
        CONFIG
    ){
        // Helper members.

        /** @type {ng.IController} */
        var vm = this;

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'SiteHeader' );


        /** Constants. */

        var INPUT_SEARCH_ID     = 'search-query',
        FORM_SEARCH_CLASS       = 'search-form';


        /** Expose to the Scope */

        $scope._        = TEXTS.HEADER;
        $scope.CONFIG   = CONFIG;


        /** Controller's API */

        vm.toggleHeaderPanel = toggleHeaderPanel;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        function init(){
            // Defaults
            vm.headerPanelOpened = false;
            vm.subpagesService   = SubpagesService;

            setWatchers();

            if ( $window.toolkitCore ) {
                $window.toolkitCore.initToolbarLoader([{ url: App.getContentMode().CMS_BASE_URL + '/__data/assets/css_file/0004/1747507/toolbar.old.css' }]);
                $window.toolkitCore.initToolbarUrlListeners();
            }
        };

        vm.$onInit = init;



        /* ===== PRIVATE FUNCTIONS ========================================== */


        // Set watchers
        function setWatchers() {
            $scope.$watch( function() {
                return $uiRouterGlobals.current.name;
            }, function( newStateName ) {
                if ( newStateName ) {
                    // Turn the header off for Degree type pages
                    vm.isHeaderOn = (SubpagesService.isDegreeSubpage() || SubpagesService.isGraduateQualSubpage()) ? false: true;

                    if ( vm.isHeaderOn ) retrieveResponseAndBind();
                }
            });
        }

        function retrieveResponseAndBind(){
            DataService.getGlobals()
                .then( function( responseObject ) {
                    vm.header = responseObject.data;
                }).catch( function( errMessage ) {
                    logger.error( "Main site's global data couldn't be retrieved. Error: %s", errMessage );
                }
            );
        }


        function toggleHeaderPanel( shouldAutofocusSearchInput ) {
            shouldAutofocusSearchInput  = shouldAutofocusSearchInput || false;
            vm.headerPanelOpened        = !vm.headerPanelOpened;

            // Autofocus search input
            if ( vm.headerPanelOpened && shouldAutofocusSearchInput ) {
                autofocusSearchInput();
            }
        }


        function autofocusSearchInput() {
            var inputSearchElement  = angular.element( $element.find( '#' + INPUT_SEARCH_ID ) ),
            formSearchElement       = angular.element( $element.find( '.' + FORM_SEARCH_CLASS )[ 0 ] );

            $animate.on( 'removeClass', formSearchElement, function( element, phase ) {
                // phase = [ 'start', 'close' ]
                if ( phase === 'close' ) {
                    inputSearchElement.focus();  // Focus when animation finishes running
                    $animate.off( formSearchElement ); // Deregister
                }
            });
        }
    }


    HeaderController.$inject = [ '$scope', '$window', '$uiRouterGlobals', '$animate', '$element','LoggerFactory', 'DataService', 'SubpagesService', 'App', 'TEXTS', 'CONFIG' ];
})();
